import { createEvent } from 'effector'

import { Point } from '@flowx/designer/modules/bpmn-editor/dictionary/geometry.types'
import { NodeDefinition } from '@flowx/designer/modules/core/dictionary/process.dictionary'

import { SequencePoints } from '../../entities/sequence.dictionary'

export type SequenceClickEvent = {
  mouseEvent: MouseEvent
  sequenceId: SequencePoints['id']
}

export type SequenceDropEvent = {
  sequenceId: SequencePoints['id']
  position: Point
  droppedEntity: Pick<NodeDefinition, 'processId' | 'type'>
}

export class BpmnSequenceEvents {
  static readonly sequenceDrop = createEvent<SequenceDropEvent>('sequenceDrop')
  static readonly sequenceDragEnter = createEvent<SequencePoints['id']>('sequenceDragEnter')
  static readonly sequenceDragLeave = createEvent<SequencePoints['id']>('sequenceDragLeave')
  static readonly sequenceLeftClick = createEvent<SequenceClickEvent>('sequenceLeftClick')
  static readonly sequenceRightClick = createEvent<SequenceClickEvent>('sequenceRightClick')
  static readonly sequenceMoving = createEvent('sequenceMoving')
}
